export const POKEMON_TYPES = {
	normal: {
		type: "normal",
        color: "#967354"
	},
	fire: {
		type: "fire",
        color: "#F08030"
	},
	water: {
		type: "water",
        color: "#6890F0"
	},
	grass: {
		type: "grass",
        color: "#79C053"
	},
	electric: {
		type: "electric",
        color: "#F8D030",
	},
	ice: {
		type: "ice",
        color: "#98D8D8"
	},
	fighting: {
		type: "fighting",
        color: "#C03028"
	},
	poison: {
		type: "poison",
        color: "#A040A0"
	},
    ground: {
		type: "ground",
        color: "#E0C068"
	},
    flying: {
		type: "flying",
        color:  "#A890F0"
	},
    psychic: {
		type: "psychic",
        color: "#F85888"
	},
    bug: {
		type: "bug",
        color: "#A8B820"
	},
    rock: {
		type: "rock",
        color: "#B8A038"
	},
    ghost: {
		type: "ghost",
        color: "#705898"
	},
    dark: {
		type: "dark",
        color: "#705848"
	},
    dragon: {
		type: "dragon",
        color:  "#7038F8"
	},
    steel: {
		type: "steel",
        color: "#B8B8D0"
	},
    fairy: {
		type: "fairy",
        color: "#F0B6BC"
	},
};
